import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { access, isAccessDenied } from '@/common/access'

import Single from '@/components/layouts/single'
import Home from '@/views/index'
import Groups from '@/views/dictionaries/groups'
import Teachers from '@/views/dictionaries/teachers'
import Cabinets from '@/views/dictionaries/cabinets'
import GroupLessons from '@/views/lessons/groupLessons'
import TeacherLessons from '@/views/lessons/teacherLessons'
import CabinetLessons from '@/views/lessons/cabinetLessons'

Vue.use(VueRouter)

function requireCabinetsAccess(to, from, next) {
  next(store.state.bootstrap.showCabinets === true ? undefined : { name: 'main', replace: true })
}

const routes = [
  {
    path: '/',
    component: Single,
    children: [
      {
        path: '',
        name: 'main',
        component: Home,
      },
      {
        path: 'groups',
        name: 'groups',
        component: Groups,
      },
      {
        path: 'teachers',
        name: 'teachers',
        component: Teachers,
      },
      {
        path: 'cabinets',
        name: 'cabinets',
        component: Cabinets,
        beforeEnter: requireCabinetsAccess,
      },
      {
        path: 'groups/:groupId/lessons',
        name: 'groups_lessons',
        component: GroupLessons,
      },
      {
        path: 'teachers/:teacherId/lessons',
        name: 'teachers_lessons',
        component: TeacherLessons,
      },
      {
        path: 'cabinets/:cabinetId/lessons',
        name: 'cabinets_lessons',
        component: CabinetLessons,
        beforeEnter: requireCabinetsAccess,
      },
    ],
  }
]

const router = new VueRouter({
  routes
})

let bootstrapPromise

router.beforeEach(async (to, from, next) => {
  try {
    if (!bootstrapPromise) {
      bootstrapPromise = store.dispatch('bootstrap/fetch')
    }

    await bootstrapPromise
    next()
  } catch (error) {
    bootstrapPromise = null

    // Закрытая паролем публикация — не ошибка навигации: App.vue уже показывает форму пароля,
    // а страницы с загрузкой данных в beforeRouteEnter открывать нельзя — они получат тот же 401
    if (isAccessDenied(error?.response)) {
      access.returnPath = to.fullPath
      next(false)
      return
    }

    next(error)
  }
})

export default router
